import React from 'react';
import logo from './logo.svg';
import './App.css';
import Home from './pages/home';
import { createBrowserRouter,Link,RouterProvider,Router } from 'react-router-dom';
import Detail from './components/detail';
import Cart from './components/cart';
import Register from './pages/register';
import Login from './pages/login';
import Verification from './pages/verification';
import Shop from './pages/shop';


const router =createBrowserRouter([
  {path:'/home',element:<Home/>},
  {path:'/detail/:id',element:<Detail/>},
  {path:'/cart',element:<Cart/>},
  {path:'/register',element:<Register/>},
  {path:'/login',element:<Login/>},
  {path:'/verification/:key',element:<Verification/>},
  {path:'/shop',element:<Shop/>}


]) 


function App() {
  return (
    <RouterProvider router={router}/>
  );
}

export default App;
